import { j as o } from "../../_virtual/jsx-runtime.js";
import { ConfigProvider as m, Button as c } from "antd";
function h(i) {
  const { width: r, height: t, style: e, ...a } = i, n = {
    ...e,
    ...r && { width: r },
    ...t && { height: t }
  };
  return /* @__PURE__ */ o.jsx(
    m,
    {
      theme: {
        components: {
          Button: {
            borderRadius: 200,
            colorPrimary: "var(--btn-primary)",
            colorPrimaryHover: "var(--btn-primary-hover)",
            colorPrimaryActive: "var(--btn-primary-active)",
            colorTextLightSolid: "var(--white)",
            colorPrimaryText: "var(--white)",
            colorPrimaryTextHover: "var(--white)",
            colorPrimaryTextActive: "var(--white)",
            primaryShadow: "0 24px 40px rgba(20, 20, 19, 0.35)",
            controlHeight: 52,
            fontWeightStrong: 600,
            paddingInline: 28
          }
        }
      },
      children: /* @__PURE__ */ o.jsx(c, { ...a, style: n })
    }
  );
}
export {
  h as default
};
